import { compose } from 'recompose';
import _ from 'lodash';
import { updatingCredentials } from '../../../utils/downloadUpdatingCredentials';
import linkWithCredentials from '../../../utils/linkWithCredentials';


/*
* Uploads attachments for a ticket
*
* In addition to the ticket ID, this function expects two maps: files and descriptions.
* These maps should contain identical keys to line up File() with their matching descriptions.
*
* Maps were chosen because the descriptions are collected using `redux-form` and its default
* data structure for storing form data is maps. Changing this default was not worth the time.
*
* It's a bit awkward and more difficult to read than it really should be -- sorry.
*
* Example:
* {
*   'file-0': File(...),
*   ...
*   'file-N': File(...),
* }
* {
*   'file-0': 'Description for file 0',
*   ...
*   'file-N': 'Description for file N',
* }
 */
export const uploadTicketAttachments = async (axios, ticketId, files, descriptions) => {
  // Manually curry mergeWith to be data last
  const mergeWithFileAndDescription = (filesObj, descriptionsObj) => {
    return _.mergeWith(filesObj, descriptionsObj, (file, description) => {
      return {
        file,
        description,
      };
    });
  };

  const attachmentUrl = `tickets/${ticketId}/attachments`;
  const formData = new FormData();
  const filesWithDescriptions = compose(
    _.values,
    mergeWithFileAndDescription,
  )(files, descriptions);

  formData.append('attachment-count', `${filesWithDescriptions.length}`);
  filesWithDescriptions.forEach((fileWithDescription, index) => {
    formData.append(`attachment-${index}`, fileWithDescription.file);
    formData.append(`attachment-description-${index}`, fileWithDescription.description);
  });

  const urlCred = linkWithCredentials(attachmentUrl);
  await axios.request({
    url: urlCred, method: 'POST', data: formData,
  }).then((response) => {
    const { headers } = response;
    updatingCredentials(headers);
  });
};


export const deleteTicketAttachment = async (axios, attachmentId) => {
  const attachmentUrl = `ticket_attachments/${attachmentId}`;

  const urlCred = linkWithCredentials(attachmentUrl);
  await axios.request({
    url: urlCred, method: 'Delete',
  }).then((response) => {
    const { headers } = response;
    updatingCredentials(headers);
  });
};
